import React from 'react';
import * as classnames from 'classnames/bind';
import {User} from '@mintdata-wsp/common/state/DataState';
import {observer} from 'mobx-react';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ActiveUserTooltip} from '@mintdata-wsp/wsp/ui/views/visualDesigner/common/ActiveUserTooltip';
import {Tooltip} from '@mintdata-wsp/mint-kit/impl/components/tooltip/Tooltip';
import {PopupAnchor, SourceAnchor} from '@mintdata-wsp/common/components/combo/Combo';

export enum UserIconSize {
    Small = 'small',
    Large = 'large',
    LargeNoMargin = 'largeNoMargin',
}

interface UserIconProps
{
    iconSize:UserIconSize;
    fullName:string;
    avatarUrl?:string;
    color:string;
    selected?:boolean;
    idle?:boolean;
    userId?:number;
    noGrayBorder?:boolean;
    onClick?(userId:number):void;
    tooltip?:boolean;

    userIconContainerClassName?:string;
}

const styles = require('./UserIcon.less');
const cx = classnames.bind(styles);

@observer
export class UserIcon extends React.Component<UserIconProps>
{
    public render():JSX.Element
    {
        const {
            color, fullName, iconSize, selected, noGrayBorder, userId, tooltip, idle, onClick,
            userIconContainerClassName
        } = this.props;

        const userStates = [];

        if( idle )
            userStates.push('idle');

        if( selected )
            userStates.push('observing');

        return <div
            className={cx('userIconContainer', iconSize,
                noGrayBorder ? 'noGrayBorder' : '', userIconContainerClassName)}
            onClick={onClick ? () => onClick(userId) : undefined}
        >
            {selected && <div className={cx('following', iconSize)} style={{backgroundColor: color}} />}
            {
                selected && <div className={cx('observingFrame')} style={{borderColor: color}}>
                    <div className={cx('observingNameplate', iconSize)} style={{backgroundColor: color}}>
                        {`Observing ${fullName}`}
                    </div>
                </div>
            }
            <Tooltip
                targetClassName={cx('tooltipTarget')}
                tooltipClassName={cx('tooltipContent')}
                closeOnTargetClick={true}
                content={tooltip && <ActiveUserTooltip fullName={userStates.length ? `${fullName} (${userStates.join(', ')})` : fullName} />}
                popoverProps={{
                    className: cx('tooltipPopover'),
                    sourceAnchor: SourceAnchor.CenterBottom,
                    popupAnchor: PopupAnchor.CenterTop,
                    ignoreEsc: true
                }}
            >
                    <div className={cx('userIconColor', iconSize, idle ? 'idle' : '')} style={{backgroundColor: color}}>
                        {this._renderInitialsOrAvatar()}
                    </div>
            </Tooltip>
        </div>
    }

    private _renderInitialsOrAvatar()
    {
        const {fullName, avatarUrl, iconSize} = this.props;

        if( avatarUrl )
            return (
                <Row className={cx('userIcon', iconSize)}>
                    <img src={avatarUrl} className={cx('avatar')}/>
                </Row>
            );

        // for "+3" users kind of icon
        const label = fullName.match(/^\+\d+$/) ? fullName : User.initialsFromFullName(fullName);
        return (
            <Row className={cx('userIcon', iconSize)}>
                {label}
            </Row>
        );
    }
}
